/* global VXConfig */
import React                        from 'react';
import PropTypes                    from 'prop-types';
import Flux                         from '../flux/Flux';
import {VXPay, VXPayAction}         from './../utils/VXPay';
import {ModalBoxEnum, openModalBox} from './ModalBox/ModalBoxFactory.js';

class ContestVoting extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isVoted: props.isVoted,
            mediaId: props.mediaId,
        };

        this.contestId = this.props.contestId;
        this.mediaId   = this.props.mediaId;
        this.actorId   = this.props.actorId;
        this.guestId   = this.props.guestId;
        this.albumId   = this.props.albumId;

        this.checkCorrectItemClicked = this.checkCorrectItemClicked.bind(this);
        this.onVotingClick           = this.onVotingClick.bind(this);
        this.onVotingChange          = this.onVotingChange.bind(this);
        this.onConfirm               = this.onConfirm.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.mediaId !== prevState.mediaId && nextProps.isVoted !== prevState.isVoted) {
            return {
                isVoted: nextProps.isVoted,
                mediaId: nextProps.mediaId
            };
        }
		return null;
	}

    componentDidMount() {
        Flux.Contest.addContestVotingChangeListener(this.onVotingChange);
    }

    checkCorrectItemClicked(contestId, mediaId, guestId) {
        return (this.props.contestId === contestId && this.props.mediaId === mediaId && this.props.guestId === guestId);
    }

    onConfirm(hideConfirmWindow) {
        Flux.Contest.addContestMediaVoting(this.props.contestId, this.props.mediaId, this.props.actorId, this.props.guestId, this.props.albumId, this.props.contestName, hideConfirmWindow);
    }

    onVotingClick(e) {
        if (e.preventDefault) {
            e.preventDefault();
        }
        if (e.stopPropagation) {
            e.stopPropagation();
        }

        if (!Flux.Guest.isLoggedIn()) {
            const action = new VXPayAction(Flux.Constants.ActionTypes.Contest.SET_SHOULD_OPEN_MEDIA, {
                config:        {
                    mediaId:     this.props.mediaId,
                    mediaType:   this.props.mediaType,
                    currentPage: this.props.currentPage,
                    voteMedia:   true,
                }, shouldOpen: true,
            });
            VXPay.openSignupOrLogin({}, action);
            return;
        }

        if (this.props.isVotingAllowed && !this.state.isVoted) {
            const guestInfo = Flux.Contest.getGuestData(this.props.contestId) || Flux.Contest.getGuestData(this.props.contestName);

            //                                  always show modal if user used all Votes
            if (guestInfo.hideVoteLimitModal && guestInfo.voteCount !== guestInfo.voteLimit) {
                this.onConfirm(true);
                return;
            }

            openModalBox(ModalBoxEnum.CONTEST_LIKE, {
                onConfirm:      this.onConfirm,
                actorName:      this.props.actorName,
                guestVoteLimit: guestInfo.voteLimit,
                guestVotesLeft: guestInfo.voteLimit - guestInfo.voteCount,
                contestId:      this.props.contestName || this.props.contestId,
            });
        }
    }

    onVotingChange(guestId, contestId, mediaId, isVoted) {
        if (this.checkCorrectItemClicked(contestId, mediaId, guestId)) {
            this.setState({isVoted: isVoted});
        }
    }


    render() {
        return (<span onClick={this.onVotingClick} className={"contents__plate-guestvoting " + this.props.styleClass + ((this.props.isVotingAllowed) ? ' h-cursor-pointer' : '') + (this.state.isVoted ? ' h-color-success' : '')}
                      {...(this.props.tooltipText ? { 'data-tooltip-content': this.props.tooltipText, 'data-tooltip-id': 'tooltip' } : {})}>
            {this.props.count > 0 && <div className="contents__plate-guestvoting-count">{this.props.count}</div>}
            <i className="icon -icon-voting-full" />
       </span>);
    }
}

ContestVoting.propTypes = {
    actorId:         PropTypes.number.isRequired,
    actorName:       PropTypes.string,
    contestId:       PropTypes.number.isRequired,
    guestId:         PropTypes.number.isRequired,
    isVoted:         PropTypes.bool.isRequired,
    mediaId:         PropTypes.number,
    albumId:         PropTypes.number,
    isVotingAllowed: PropTypes.bool,
    styleClass:      PropTypes.string,
    mediaType:       PropTypes.string,
    currentPage:     PropTypes.number,
    contestArea:     PropTypes.string.isRequired,
    contestName:     PropTypes.string.isRequired,
    count:           PropTypes.number,
    tooltipText:     PropTypes.string,
};

ContestVoting.defaultProps = {
    actorId:         0,
    contestId:       0,
    guestId:         0,
    isVoted:         false,
    mediaId:         0,
    albumId:         0,
    isVotingAllowed: false,
    styleClass:      '',
    mediaType:       '',
    currentPage:     null,
    actorName:       '',
    contestArea:     '',
    contestName:     '',
    count:           0,
    tooltipText:     '',
};

export default ContestVoting;
